import getJSONP, { HOST, BASE_URL } from "./request";
import { getPlatform, justifyDeviceType } from "@utiles/index";

const PLATFORM = getPlatform();
const ajaxUrl = {
  getWebsiteConfig: {
    global: `${BASE_URL}/website/getWebsiteConfig`,
    gm99: ``,
  },
  getWebsiteClass: {
    global: `${BASE_URL}/website/getWebsiteClass`,
    gm99: ``,
  },
  checkLogin: {
    global: `//gpassport.${HOST}/center/ajax/get_store_user_json`,
  },
  login: {
    global: (gameId) =>
      `//gabres.${HOST}/platform/login.html?gameId=${gameId}&device=${
        justifyDeviceType().isPhone() ? 2 : 1
      }&forward=${encodeURIComponent(window.location.href)}`,
  },
};

export const getWebsiteConfig = (data) => {
  return getJSONP(ajaxUrl.getWebsiteConfig[PLATFORM], data);
};

export const getWebsiteClass = (data) => {
  return getJSONP(ajaxUrl.getWebsiteClass[PLATFORM], data);
};

export const checkLoginType = (data) => {
  return getJSONP(ajaxUrl.checkLogin[PLATFORM], data);
};

export const goLogin = (gameId) => {
  window.location.href = ajaxUrl.login[PLATFORM](gameId);
};
